let config: any;

if (process.env.NODE_ENV === 'production') {
  config = {
    adminusUrl: 'https://adminus.prod.tda.link/',
  };
} else {
  config = {
    adminusUrl: 'https://adminus.prod.tda.link/',
  };
}

export { config };
